// extracted by mini-css-extract-plugin
export default {"search-header":"HjHb9k","search-header__button":"s86XrB"};